import { Deserializable } from '../protocols/deserializable';
import { FundType } from './fund-type';
import { DonutChartData } from '../../views/shared/components/donut-chart/donut-chart-data';

export class MemberAccountFundAllocation implements Deserializable {
  public fundId!: number;
  public fund!: FundType;
  // User inputted percentage of users total balance amongst all funds
  public percentageOfTotalBalance!: number;
  // User inputted total balance of this particular fund
  public totalBalance!: number;

  public constructor(fundId: number, fund: FundType, percentageOfTotalBalance: number, totalBalance: number) {
    this.fundId = fundId;
    this.fund = fund;
    this.percentageOfTotalBalance = percentageOfTotalBalance;
    this.totalBalance = totalBalance;
  }

  public onDeserialize() {
    if (this.fund) {
      this.fund = window?.injector?.Deserialize.instanceOf(FundType, this.fund);
    }
  }

  public asDonutChartData(): DonutChartData {
    return {
      label: this.fund.name,
      amount: this.totalBalance,
      percentage: this.percentageOfTotalBalance.toFixed(2),
      color: this.fund.getChartDataColor()
    };
  }

  public isCashFund(): boolean {
    return this.fundId === 1;
  }
}
